import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1)

import { reactive, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import SwitchLang from "@/components/element/lang/SwitchLang.vue";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
import User from "@/components/user/User.vue";
import UserInform from "@/layouts/dashboard/nav/user/UserInfor.vue";
interface props {
  navbarFixed: boolean;
  sidebarCollapsed: boolean;
  notificationsData: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardHeader',
  props: {
    navbarFixed: { type: Boolean, default: false },
    sidebarCollapsed: { type: Boolean, default: false },
    notificationsData: { default: () => [] }
  },
  setup(__props: any) {

const route = useRoute();
const propsData = __props;
const top = ref(0);
const resizeEventHandler = () => {
  top.value = top.value ? 0 : -0.01;
};
onMounted(() => {
  window.addEventListener("resize", resizeEventHandler);
});

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.navbarFixed ? 'a-affix' : 'div'), { "offset-top": top.value }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { type: "flex" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 24,
                md: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(Breadcrumb)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 24,
                md: 18,
                class: "header-control"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: "sidebar-toggler",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.$emit('toggleSidebar', !_ctx.sidebarCollapsed), resizeEventHandler()
            ))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, { type: "link" }, {
                    default: _withCtx(() => [
                      _createVNode(SwitchLang)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    type: "link",
                    ref: "secondarySidebarTriggerBtn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleSettingsDrawer', true)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }, 512),
                  _createVNode(UserInform)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["offset-top"]))
}
}

})